<template>
    <div :class="headerClass">
        <div class="grid-container">
            <div class="nav--holder grid-x grid-x-padding align-middle">
                <nav class="nav cell small-12">
                    <div class="button_menu--holder">
                        <button type="button" name="button_menu" :class="buttonMenuClass" v-on:click="toggleMenu">
                            <svg class="icon icon-open-button"><use xlink:href="#icon-open-button"></use></svg>
                            <span class="button_menu--label">MENU</span>

                            <svg class="icon icon-close-button"><use xlink:href="#icon-close-button"></use></svg>
                        </button>
                    </div>

                    <ul :class="menuClass">
                        <li class="cell shrink">
                            <a href="#top" title="Top" v-smooth-scroll="{ duration: 1000 }" @click="closeMenu()">Top</a>
                        </li>
                        <li class="cell shrink">
                            <a href="#about" title="About the movie" v-smooth-scroll="{ duration: 1000 }" @click="closeMenu()">About the movie</a>
                        </li>
                        <li class="cell shrink">
                            <a href="https://www.facebook.com/netemosametemo.movie/" title="News" target="_blank">News</a>
                        </li>
                        <li class="cell shrink">
                            <a href="#trailer" title="Trailer" v-smooth-scroll="{ duration: 1000 }" @click.prevent="openTrailer()">Trailer</a>
                        </li>
                        <!--<li class="cell shrink">
                            <a href="#reviews" title="Reviews" v-smooth-scroll="{ duration: 1000 }" @click="closeMenu()">Reviews</a>
                        </li>
                        <li class="cell shrink">
                            <a href="#theater" title="Theater" v-smooth-scroll="{ duration: 1000 }" @click="closeMenu()">Theater</a>
                        </li>-->
                    </ul>
                </nav>
            </div>
        </div>

        <modal-trailer :isActive="isActiveModal" v-on:closeModal="closeTrailer"></modal-trailer>
    </div>
</template>

<script>
import Vue from 'vue'
import ModalTrailer from '@/components/ModalTrailer'
import vueSmoothScroll from 'vue-smooth-scroll'

Vue.use(vueSmoothScroll)
Vue.component('modal-trailer', ModalTrailer)

export default {
    name: 'navigation',
    data () {
        return {
            showMenu: false,
            isActiveModal: false
        }
    },

    computed: {
        headerClass () {
            if (this.showMenu) {
                return 'navigation fade_in_intro is-active'
            } else {
                return 'navigation fade_in_intro'
            }
        },
        menuClass () {
            if (this.showMenu) {
                return 'grid-x menu align-center is-active'
            } else {
                return 'grid-x menu align-center'
            }
        },
        snsClass () {
            if (this.showMenu) {
                return 'sns_menu cell shrink is-active'
            } else {
                return 'sns_menu cell shrink'
            }
        },
        buttonMenuClass () {
            if (this.showMenu) {
                return 'button_menu is-active'
            } else {
                return 'button_menu'
            }
        }
    },

    methods: {
        toggleMenu () {
            if (this.showMenu) {
                this.showMenu = false
            } else {
                this.showMenu = true
            }
        },
        closeMenu () {
            this.showMenu = false
        },

        openTrailer () {
            this.showMenu = false
            this.isActiveModal = true
        },
        closeTrailer () {
            this.isActiveModal = false
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Navigation.vue